import React from "react";
import { Route, Routes } from "react-router-dom";
import logo from "./assets/copel-logo.png";

import "./App.css";

import "./App.scss";

import { UcSearchScreen } from "./pages/UcSearchScreen";
import { ResultScreen } from "./pages/ResultScreen";
import { ConfirmationScreen } from "./pages/ConfirmationScreen";

const App: React.FC = () => {
  return (
    <div className="App">
      <header className="App-header mb-6">
        <img
          className="App-logo"
          alt="logo"
          src={logo}
        />

        <h1 className="title">Pesquisar unidade consumidora</h1>
      </header>

      <Routes>
        <Route path="/" element={<UcSearchScreen />} />
        <Route path="/result" element={<ResultScreen />} />
        <Route path="/confirmation" element={<ConfirmationScreen />} />
      </Routes>
    </div>
  );
};

export default App;
